import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LatLng, latLng, MapOptions, tileLayer, Marker, marker, map } from 'leaflet';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeocodingService } from '../../../services/geocoding.service';
import { DataService } from '../../../services/data.service';
import { TranslateService } from '@ngx-translate/core';
import * as rxmap from 'rxjs/operators';
import * as L from 'leaflet';
import { StreetViewService } from 'src/app/services/street-view.service';
import { StreetViewModalComponent } from '../street-view-modal/street-view-modal.component';
import _ from "lodash";
import { AppConfig } from 'src/app/app.config';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, switchMap, tap, map as rxjsmap, distinctUntilChanged } from 'rxjs/operators';
import { ErrorModalComponent } from '../error-modal/error-modal.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-project',
  templateUrl: './add-project.component.html',
  styleUrls: ['./add-project.component.scss']
})
export class AddProjectComponent extends NgbActiveModal implements OnInit {

  public leafletOptions: MapOptions;
  public layers: any[];
  public projectId;
  public project: any = {
    name: null,
    email: null,
    point: null,
    address: {
      country: null,
      postalCode: null,
      municipality: null,
      street: null,
      houseNumber: null,
      boxNumber: null
    },
    freeToRegister: false
  };
  public zeus_status = false;
  public center: LatLng = new LatLng(0, 0);
  private map: any;
  public marker: any;
  public headline = "Add Project";
  public btnText = "Add";

  address$: Observable<any[]>;
  addressLoading = false;
  addressInput$ = new Subject<string>();

  public countries = [];

  projectName = environment.projectName

  constructor(
    private cd: ChangeDetectorRef,
    public activeModal: NgbActiveModal,
    private geocodingService: GeocodingService,
    private dataService: DataService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private streetViewService: StreetViewService,
    private appConfig: AppConfig
  ) {
    super();
  }

  ngOnInit() {
    this.zeus_status = localStorage.getItem('zeus_status') === 'true';
    if (this.projectId || this.project) {
      console.log('It"s edit mode');
      this.headline = "Edit Project";
      this.btnText = "Save";
      this.project.address.country = (this.project.address.country || '').toLowerCase();
    }
    let tileLayerOptions = {
      maxZoom: 18,
      id: 'mapbox.streets',
      accessToken: 'pk.eyJ1IjoiYW50b242Mzc4IiwiYSI6IlBtMG5pMjgifQ.bGiCZKEStTnO5YjSzmkJZg'
    };


    const center = _.cloneDeep(this.project.point);
    const pos = center ? latLng(center.coordinates.reverse()) : latLng(50.848656786354994, 4.349341392517091);

    this.leafletOptions = {
      layers: [
        // tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', tileLayerOptions)
        this.appConfig.getTileLayer()
      ],
      zoom: 14,
      center: pos,
      zoomControl: false,
      drawControl: false
    };
    this.map = map('map', this.leafletOptions);
    this.map.on('click', this.getCoordinates.bind(this));
    if (this.project.point) {
      this.addMarker(pos);
      setTimeout(() => this.map.invalidateSize(), 100);
    }

    const browserLang = this.translate.currentLang;

    this.dataService.getDictionary(browserLang)
      .pipe(
        rxmap.map((i) => {
          let temp = [];
          const countryKeys = Object.keys(i).filter(key => key.includes('country'));
          countryKeys.forEach(key => {
            temp.push({
              'key': key,
              'value': i[key]
            });
          })

          return temp;
        })
      )
      .subscribe(items => {
        this.countries = items.sort(compare);
      });

    const compare = (a, b) => {
      // Use toUpperCase() to ignore character casing
      const valueA = a.value.toUpperCase();
      const valueB = b.value.toUpperCase();

      let comparison = 0;
      if (valueA > valueB) {
        comparison = 1;
      } else if (valueA < valueB) {
        comparison = -1;
      }
      return comparison;
    };

    this.translate.onLangChange.subscribe((e) => {
      let temp = [];
      const countryKeys = Object.keys(e['translations']).filter(key => key.includes('country'));
      countryKeys.forEach(key => {
        temp.push({
          'key': key,
          'value': e['translations'][key]
        });
      })
      this.countries = temp.sort(compare);
    });
    this.initTypeahead();
    this.cd.detectChanges();
  }

  closeModal() {
    this.activeModal.dismiss('close');
  }

  markerDrag(event) {

    this.project.point = {
      type: 'Point',
      coordinates: [
        event.target._latlng.lng.toString(),
        event.target._latlng.lat.toString(),
      ]
    };
  }

  addMarker(e): void {
    if (this.marker) {
      this.marker.setLatLng(e);
      this.marker.dragging.enable();
    }
    else {
      this.marker = marker(e).addTo(this.map);
      this.marker.dragging.enable();
    }
    this.marker.on('dragend', this.markerDrag.bind(this));
  }

  getCoordinates(event) {
    this.addMarker(event.latlng);
    this.geocodingService.findAddress(event.latlng.lat, event.latlng.lng).subscribe(response => {
      this.project.address = {
        country: `country_${response.country}`,
        postalCode: response.postalCode,
        municipality: response.municipality,
        street: response.street,
        houseNumber: response.houseNumber,
        boxNumber: response.boxNumber
      };
      this.project.point = {
        type: 'Point',
        coordinates: [
          event.latlng.lng.toString(),
          event.latlng.lat.toString(),
        ]
      };

      this.streetViewService.generatePanoramaObject({ lat: event.latlng.lat, lng: event.latlng.lng })
        .then(data => {
          const svModal = this.modalService.open(StreetViewModalComponent, {
            size: 'lg',
            backdrop: 'static'
          });
          const componentInstance = svModal.componentInstance;
          componentInstance.data = data;
          componentInstance.disabled = true;
        })
        .catch(status => {
          console.log(`No street view available: ${status}`);
        });
    }, err => {
      if (err.status === 404) {
        this.project.address = {
          country: '',
          postalCode: '',
          municipality: '',
          street: '',
          houseNumber: '',
          boxNumber: ''
        };
        const errDlg = this.modalService.open(ErrorModalComponent);
        errDlg.componentInstance.header = 'Unknown address';
        errDlg.componentInstance.message = 'The address of this location could not be determined. Please select a new location.';
        errDlg.result.then(() => {
          this.map.removeLayer(this.marker)
          this.marker = null;
        });
      }
    });
  }

  initTypeahead() {
    const projectLocation = localStorage.getItem('project_location');
    this.address$ = concat(
      of([]),
      this.addressInput$.pipe(
        distinctUntilChanged(),
        tap(() => this.addressLoading = true),
        switchMap(term => {
          if (term) {
            console.log(this.map.getCenter());
            let latlng;
            if (!projectLocation) { latlng = this.map.getCenter(); } else {
              const locations = projectLocation.split(',');
              const latitude = parseFloat(locations[1]);
              const longitude = parseFloat(locations[0]);
              latlng = L.latLng(latitude, longitude);
            }
            return this.geocodingService.addressAutocomplete(term, latlng.lat, latlng.lng).pipe(
              catchError(() => of([])),
              rxjsmap(result => {
                if (result.features) {
                  return result.features.map(r => Object.assign(r.properties, r.geometry));
                } else {
                  return [];
                }
              }),
              tap(() => this.addressLoading = false)
            );
          }
          this.addressLoading = false;
          // return of([]).pipe(
          //   map(() => this.addressLoading = false)
          // );
        })
      )
    )
  }

  findPos(latlng) {
    this.map.panTo({ lng: latlng.lon ? latlng.lon : latlng.lng, lat: latlng.lat });
    this.map.setZoom(18);
  }

  onInputAddress(event) {
    console.log('input', event);
    if (event.coordinates) {
      const latlng = L.latLng(event.coordinates[1], event.coordinates[0]);
      this.findPos(latlng);
    } else if (event.name) {
      this.geocodingService.findPosition(event.name).subscribe(response => {
        if (response && response.lat) this.findPos(response);
      }, err => {
        const errDlg = this.modalService.open(ErrorModalComponent);
        errDlg.componentInstance.header = 'Unknown address';
        errDlg.componentInstance.message = 'The location of this address could not be determined. Please enter a new address.';
      });
    }
  }

  // onInputAddress(event) {
  //   this.geocodingService.findPosition(event.target.value).subscribe(response => {
  //     this.center.lat = response.lat;
  //     this.center.lng = response.lon;
  //     this.map.panTo({ lng: response.lon, lat: response.lat });
  //     this.map.setZoom(18);
  //     this.project.point = {
  //       type: 'Point',
  //       coordinates: [
  //         response.lon.toString(),
  //         response.lat.toString(),
  //       ]
  //     };
  //   })
  // }

  isValid() {
    if (this.project) {
      return this.project.name &&
        this.project.email &&
        this.project.address.municipality &&
        this.project.address.street &&
        this.project.address.postalCode;
    }
    return true;

  }
}
